import type {
  ClientToken,
  SecureInputsFields,
  HighnoteEnvironment,
  SecureInputsElements,
  SecureInputsCardBrand,
} from "@highnoteplatform/types";

import { iframeUri } from "./config";

interface BuildFrameConfig {
  clientToken: ClientToken;
  uuid: string;
  field: SecureInputsFields;
  elementConfig: SecureInputsElements;
  environment: HighnoteEnvironment;
  fields: SecureInputsFields[];
  excludedCardBrands?: SecureInputsCardBrand[];
}

const buildFrameSource = (config: BuildFrameConfig) => {
  const {
    clientToken,
    elementConfig: elementConfigMap,
    field,
    environment,
    uuid,
    fields,
    excludedCardBrands = [],
  } = config;
  const { styles } = elementConfigMap[field] ?? {};
  const searchParameters = new URLSearchParams();

  searchParameters.set("field", field);
  searchParameters.set("environment", environment);
  searchParameters.set("fields", fields.join("|"));
  searchParameters.set("styles", JSON.stringify(styles ?? {}));
  searchParameters.set("excludedCardBrands", excludedCardBrands.join("|"));

  switch (field) {
    case "pin": {
      const {
        paymentCardId = "",
        masked = false,
        showToggle = false,
      } = elementConfigMap.pin ?? {};

      searchParameters.set("token", clientToken);
      searchParameters.set("paymentCardId", paymentCardId);
      searchParameters.set("masked", String(masked));
      searchParameters.set("showToggle", String(showToggle));

      break;
    }
    case "cardNumber":
      searchParameters.set("token", clientToken);

      break;

    default:
      break;
  }

  const frameSource = new URL(
    `${iframeUri(environment)}?${searchParameters.toString()}`
  );

  frameSource.hash = uuid;

  return frameSource;
};

export const buildFrame = (config: BuildFrameConfig): HTMLIFrameElement => {
  const frame = document.createElement("iframe");
  const frameSource = buildFrameSource(config);

  frame.setAttribute("src", frameSource.toString());
  frame.style.setProperty("border", "none");

  return frame;
};
